export function synchronizeData(apiCall) {
  setInterval(() => {
    apiCall();
  }, 600000);
}
